import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { UserAnalyticsByDaysModel } from '../models/UserAnalyticsByDaysModel';
import { GetUserActivityDetailsParam } from '../api/UserAnalyticsApi';
import { UserActivityHistoryModel } from '../models/UserActivityHistoryModel';

interface UserAnalyticsState {
    openModal: boolean,
    selectedUserId: number,
    selectedDay: number,
    selectedUserAnalyticsByDays: UserAnalyticsByDaysModel[],
    selectedUserActivityDetailsParam: GetUserActivityDetailsParam | null,
    userActivityDetails: UserActivityHistoryModel[]
}

const initialState: UserAnalyticsState = {
    openModal: false,
    selectedUserId: 0,
    selectedDay: 3,
    selectedUserAnalyticsByDays: [],
    selectedUserActivityDetailsParam: null,
    userActivityDetails: []
}

export const UserAnalyticsSlice = createSlice({
    name: "UserAnalytics",
    initialState,
    reducers: {
        setOpenModal: (state, action: PayloadAction<boolean>) => {
            state.openModal = action.payload;
        },
        setSelectedAnalyticsUserId: (state, action: PayloadAction<number>) => {
            state.selectedUserId = action.payload;
        },
        setSelectedDay: (state, action: PayloadAction<number>) => {
            state.selectedDay = action.payload;
        },
        setSelectedUserAnalyticsByDays: (state, action: PayloadAction<UserAnalyticsByDaysModel[]>) => {
            state.selectedUserAnalyticsByDays = action.payload;
        },
        setSelectedUserActivityDetailsParam: (state, action: PayloadAction<GetUserActivityDetailsParam | null>) => {
            state.selectedUserActivityDetailsParam = action.payload;
        },
        setUserActivityDetails: (state, action: PayloadAction<UserActivityHistoryModel[]>) => {
            state.userActivityDetails = action.payload;
        },
    }
});

export const UserAnalyticsSelector = createSelector(
    (state: RootState) => state.userAnalytics,
    (data) => data
);

export const {
    setOpenModal,
    setSelectedAnalyticsUserId,
    setSelectedDay,
    setSelectedUserAnalyticsByDays,
    setSelectedUserActivityDetailsParam,
    setUserActivityDetails
} = UserAnalyticsSlice.actions;

export default UserAnalyticsSlice.reducer;